import store from '../store'
import { LoginType } from '@/store/mutation-types'

const SSO_ORIGIN = process.env.VUE_APP_OAUTH_LOGIN_URL

const SSO_AUTHORIZE_PATH = '/oauth/authorize'

export const CLIENT_ID = 'supplier-client'

export const RESPONSE_TYPE = 'code'

export const REDIRECT_URI = process.env.VUE_APP_WEB_SERVER

export const TYPE = '2' // 代理机构

const SSO_PARAMS = `client_id=${CLIENT_ID}&response_type=${RESPONSE_TYPE}&type=${TYPE}&redirect_uri=${REDIRECT_URI}`

export const SSO_LOGIN_URI = `${SSO_ORIGIN}${SSO_AUTHORIZE_PATH}?${SSO_PARAMS}`

const SSO_LOGOUT_PATH = '/logout'

const SSO_LOGOUT_URI = `${SSO_ORIGIN}${SSO_LOGOUT_PATH}?${SSO_PARAMS}`

export const SSO_CODE_CALLBACK = process.env.VUE_APP_API_SERVER + '/api/1/auth/callback/supplier'

export const redirect2Login = () => {
  tokenTimeoutProcessing = false
  location.href = SSO_LOGIN_URI
}

export const redirect2Logout = () => {
  if (store.getters.loginType === LoginType.COMMON) {
    location.href = REDIRECT_URI + '/#/login'
  } else {
    location.href = SSO_LOGOUT_URI
  }
  store.commit('LOGIN_TYPE', '')
}

let tokenTimeoutProcessing = false
// 避免多次弹出信息提醒用户token已过期
export const shouldAlertAuthTimeout = () => {
  if (tokenTimeoutProcessing) {
    return false
  } else {
    tokenTimeoutProcessing = true
    return true
  }
}
